





















import { Component, Vue } from "vue-property-decorator";
import AppFooter from "@/components/AppFooter.vue";

@Component({
  components: { AppFooter }
})
export default class Error extends Vue {
  error = "";

  created() {
    if (this.$route.query && this.$route.query.code) {
      this.error = this.$route.query.code.toString();
    }
  }

  get lang() {
    return this.$store.state.lang.data;
  }
}
